import "leaflet/dist/leaflet.css";
import _ from "lodash";
import { Construction, LucideProps, icons } from "lucide-react";

export const Icon = ({ icon, ...props }: { icon: string } & LucideProps) => {
  type LucideIconName = keyof typeof icons;

  const customIconKey = _.startCase(icon).replaceAll(" ", "");

  if (customIconKey in icons) {
    const LucideIcon = icons[customIconKey as LucideIconName];
    return <LucideIcon {...props} />;
  } else {
    return <Construction {...props} />;
  }
};
